module.exports = __webpack_public_path__ + "img/mswt.41ccde2e.png";